// frontend/src/pages/Reinsurance/components/common/ReinsuranceCard/index.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFileContract, faClipboardList, faMoneyBillWave, 
  faChartLine, faBuilding, faUsers, faChartBar,
  faExclamationTriangle, faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import styles from './ReinsuranceCard.module.css';

const ReinsuranceCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend, 
  format = 'number',
  onClick,
  status = 'default', // 'default', 'success', 'warning', 'danger'
  actionText,
  actionIcon
}) => {
  // Format the value based on the format prop
  const formatValue = () => {
    if (value == null) return '-';
    
    switch (format) {
      case 'currency':
        return new Intl.NumberFormat('en-US', { 
          style: 'currency', 
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(value);
      case 'percentage':
        return `${value}%`;
      case 'number':
      default:
        return new Intl.NumberFormat('en-US').format(value);
    }
  };
  
  // Get the appropriate icon
  const getIcon = () => {
    switch (icon) {
      case 'contract':
        return faFileContract;
      case 'claim':
        return faClipboardList;
      case 'capital':
        return faMoneyBillWave;
      case 'exposure':
      case 'risk':
        return faChartLine;
      case 'cedent':
        return faBuilding;
      case 'investor':
        return faUsers;
      case 'report':
        return faChartBar;
      case 'warning':
        return faExclamationTriangle;
      case 'success':
        return faCheckCircle;
      default:
        return faFileContract;
    }
  };
  
  // Get trend indicator
  const getTrendIndicator = () => {
    if (!trend) return null;
    
    const isPositive = trend > 0;
    const trendValue = Math.abs(trend);
    const formattedTrend = format === 'percentage' 
      ? `${trendValue}%` 
      : `${trendValue}%`;
    
    return (
      <div className={`${styles.trend} ${isPositive ? styles.positive : styles.negative}`}>
        <span>{isPositive ? '↑' : '↓'}</span>
        <span>{formattedTrend}</span>
      </div>
    );
  };
  
  return (
    <div 
      className={`${styles.card} ${styles[status]} ${onClick ? styles.clickable : ''}`}
    >
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={getIcon()} className={styles.icon} />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.valueContainer}>
          <p className={styles.value}>{formatValue()}</p>
          {getTrendIndicator()}
        </div>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        
        {actionText && actionIcon && (
          <button onClick={onClick} className={styles.actionLink}>
            <span>{actionText}</span>
            <FontAwesomeIcon icon={actionIcon} className={styles.actionIcon} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ReinsuranceCard;